<template>
  <div class="exposure-container">
    <small-header title="曝光台" moreLink="/exposure" more></small-header>
    <div class="exposure-main">
      <div class="exposure-main-img"></div>
      <div class="exposure-main-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="exposure-main-list-item"
          @click="toDetail(item)">
          <div class="exposure-main-list-item-title">{{ item.title }}</div>
          <div class="exposure-main-list-item-time">{{ $parseTime(item.publishTime, '{y}-{m}-{d}') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExposureList } from '@/api'

export default {
  data() {
    return {
      loading: true,
      list: [],
    }
  },
  mounted() {
    getExposureList({
    }).then(res => {
      this.list = res.rows.slice(0, 5)
      this.loading = false
    })
  },
  methods: {
    toDetail(obj) {
      this.$setCurArticle(obj)
      this.$router.push('/news-detail')
    }
  }
}
</script>

<style lang="scss" scoped>
.exposure-container {
  width: 1200px;
  margin: 60px auto 0;
  background: #fff;
  .exposure-main {
    padding: 0 30px 30px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 30px;
    .exposure-main-img {
      width: 461px;
      height: 310px;
      background-image: url("../../../../assets/img/bgt.png");
      background-size: cover;
      background-position: center center;
    }
    .exposure-main-list {
      margin-left: 30px;
      .exposure-main-list-item {
        width: 651px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px dashed #CBD0D5;
        cursor: pointer;
        .exposure-main-list-item-title {
          width: 500px;
          font-size: 18px;
          color: #484E54;
          line-height: 65px;
          transition: all 300ms;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .exposure-main-list-item-time {
          font-size: 18px;
          color: #8F98A0;
          line-height: 65px;
          transition: all 300ms;
        }
      }
      .exposure-main-list-item:nth-child(1) {
        border: none;
      }
      .exposure-main-list-item:hover {
        .exposure-main-list-item-title,.exposure-main-list-item-time {
          color: #1279EC;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Exposure/index.vue